import {Component, Input} from '@angular/core';

@Component({
    selector: 'app-button-loader',
    templateUrl: './button-loader.component.html',
    styleUrls: ['./button-loader.component.scss'],
    standalone: true
})
export class ButtonLoaderComponent {
  @Input() btnLoaderHeight = '20px';
}
